export default __webpack_public_path__ + "8e0bc5f3fcba43060a3029e3af1f5f3a.svg";